export enum VisitBucketStatusEnum {
  NotStarted = 1,
  InProgress = 2,
  OnHold = 3,
  Completed = 4,
  Cancelled = 5
}

export const VisitBucketStatusOptions = [
{ id: 1, label: 'Not Started' },
{ id: 2, label: 'In Progress' },
{ id: 3, label: 'On Hold' },
{ id: 4, label: 'Completed' },
{ id: 5, label: 'Cancelled' }
];
